import { render, staticRenderFns } from "./ViberDetailIncomingInfo.vue?vue&type=template&id=4a3445cd&"
import script from "./ViberDetailIncomingInfo.vue?vue&type=script&lang=ts&"
export * from "./ViberDetailIncomingInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports